import { render, staticRenderFns } from "./metadata-widget.vue?vue&type=template&id=54f81021"
import script from "./metadata-widget.vue?vue&type=script&lang=js"
export * from "./metadata-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports